// extracted by mini-css-extract-plugin
module.exports = {"toolsHeaderLogo":"global_toolsHeaderLogo__NZuNI","ctaTakeover":"global_ctaTakeover__o112V"};